<template>
  <div class="image-wrap" @click="onImgClick">
    <div class="img verticalM" v-if="!onlyImage">
      <!-- 需要懒加载 -->
      <img
        class="verticalM-box"
        v-lazy="imgPath"
        :class="{ floatL: isLeftRight }"
        :style="imgStyle"
      />
    </div>
    <div class="detail" :class="{ floatL: isLeftRight }" v-if="!onlyImage">
      <div
        class="title ellipsis"
        v-if="titleText"
        :title="titleText == true ? '' : titleText"
      >
        <slot name="title">{{ titleText }}</slot>
      </div>
      <div class="money" v-if="moneyText">
        <span :class="{ width: orginalCost > 0 }" class="nowCost ellipsis">
          <samp v-if="moneyText > 0">¥</samp>
          <slot name="money">{{ moneyText }}</slot>
        </span>
        <span v-if="orginalCost && orginalCost > 0" class="orginalCost">
          <samp>¥</samp>
          <samp>
            <slot name="orginalCost">{{ orginalCost }}</slot>
          </samp>
        </span>
      </div>
    </div>
    <div :class="{ clearfix: isLeftRight }" v-if="!onlyImage"></div>
    <!-- 只有图片无需懒加载 -->
    <slot name="image" v-if="onlyImage">
      <img :src="imagePath" :style="imgStyle" />
    </slot>
  </div>
</template>
<script type="text/javascript">
import Constant from "@/Constant";
export default {
  props: {
    isLeftRight: Boolean, //是否是左右结构
    imagePath: String, //图片路径
    defaultPath: String, //默认图片路径
    titleText: [String, Boolean], //title
    moneyText: [String, Boolean], //money
    outSideBox: Boolean, //外边框阴影
    isNewProduct: Boolean, //是否是新品
    onlyImage: Boolean, //是否需要懒加载
    orginalCost: String, //原价
    width: Number,
    height: Number,
    imgStyle: Object,
    eventparam: Object,
  },
  data() {
    return {
      isOverflow: false,
    };
  },
  computed: {
    imgPath() {
      if (this.imagePath) {
        let src = this.imagePath;
        if (this.width && this.height) {
          let strArr = this.imagePath.split(".");
          strArr[0] = strArr[0] + "-" + this.width + "-" + this.height;
          src = strArr.join(".");
        } else if (this.width) {
          let strArr = this.imagePath.split(".");
          strArr[0] = strArr[0] + "-" + this.width;
          src = strArr.join(".");
        } else if (!this.width || !this.height) {
          src = this.imagePath;
        }
        return Constant.imgBaseUrl + "/" + src;
      } else {
        return this.defaultPath;
      }
    },
  },
  methods: {
    onImgClick() {
      this.$emit("eventclick", this.eventparam);
    },
  },
  created() {
    //console.log(Constant.imgBaseUrl + '/' + this.imagePath)
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "src/common/sass/mixin.scss";
.image-wrap {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
  }
  .img {
    position: relative;
    img {
      /* display: block; */
      width: 100%;
      &.floatL {
        width: 45%;
      }
    }
  }
  .detail {
    text-align: center;
    .title {
      display: block;
      width: auto;
      margin: 0.2rem 0.3rem;
      color: #444444;
      word-break: break-all;
      overflow: hidden;
      @include font-dpr(12px);
      /*临时添加   解决title文字字数太少无法扩充空间*/
      /*min-height: 92px;*/
    }
    .money {
      margin-bottom: 0.275rem;
      color: #f80000;
      word-break: break-all;
      @include font-dpr(14px);
      .nowCost {
        color: #e60012;
        &.width {
          display: inline-block;
          width: auto;
          max-width: 50%;
          vertical-align: bottom;
        }
        > samp {
          @include font-dpr(10px);
        }
      }
      .orginalCost {
        margin-left: 10px;
        @include font-dpr(12px);
        color: #999999;
        > samp {
          position: relative;
          @include line(0, 0, #999999, 1px);
        }
      }
    }
    &.floatL {
      width: 55%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// image.vue?739293b3